<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st7"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <div class="page_title">
          <el-button
            v-if="getLimit('Balance_search_button')"
            @click="funcFilter()"
          >
            查询
          </el-button>
          <!-- <el-button
          v-if="getLimit('Balance_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button> -->
          <div class="warn">
            <div class="warn_title">对公账户信息</div>
            由贵公司开户行对合作公司账户进行充值，2~5分钟后进行手动刷新，即可显示充值金额。
          </div>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      :loading="loading"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
      :footer-method="footerMethod"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <!-- <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="机构"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="enterpriseName"
          title="企业名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.enterpriseName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="groupName"
          title="承运主体"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.groupName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankName"
          title="开户银行"
          min-width="250"
          sortable
        >
          <template v-slot="{ row }">
            {{ "光大银行青岛重庆南路支行" }}
          </template>
        </vxe-table-column>

        <template v-slot:header>
          <el-input
            v-model="listQuery.bankName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="subAcc"
          title="银行账号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.subAcc" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unionPayNumber"
          title="联行号"
          min-width="200"
          sortable
        >
          <template v-slot="{ row }">
            {{ "303452053141" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input v-model="listQuery.subAcc" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column
        field="balance"
        title="账户余额"
        min-width="200"
        sortable
      />
      <vxe-table-column title="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('Balance_variationdetails_button')"
            class="item"
            effect="dark"
            content="变动明细"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => showModel(scope.row.code, 'Detail')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('Balance_variationdetails_button')"
            class="item"
            effect="dark"
            content="刷新"
            placement="top"
          >
            <vxe-button type="text" @click="funcRefresh(scope.row)">
              <i class="el-icon-refresh-right" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelDetailFlag"
      width="1200"
      height="80%"
      title="变动明细"
      resize
    >
      <compDetail ref="DetailRef" />
    </vxe-modal>
    <merchant ref="merchantRef" :parent-data="parentData" />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { checkbalance } from "@/api/shipment";

import { partyBalanceStatistics } from "@/api/invoice";
import merchant from "./components/merchant";
import compDetail from "./components/Variationdetails";
import { getListDict } from "@/api/commonApi";
export default {
  components: {
    compDetail,
    merchant
  },
  data() {
    return {
      bankList: [],
      loading: false,
      modelDetailFlag: false,
      tableData: [],
      balanceGmtModifiedRange: "",
      exportObj: {
        exportUrl: "/ntocc-basic-api/party/exportPartyBalanceStatistics", //导出接口
        name: "余额统计"
      },
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      // Pagingconf: [],
      partyTypeOptions: [
        {
          label: "实际承运人",
          value: "driver"
        },
        {
          label: "车队长",
          value: "driver_leader"
        },
        {
          label: "企业托运人",
          value: "shipment_company"
        },
        {
          label: "个体托运人",
          value: "shipment"
        }
      ],
      sumObject: {},
      // 网商余额
      parentData: {},
      // 机构列表
      branchList: this.$store.state.components.branchList,
      isDriver: false
    };
  },
  created() {
    // 获取数据字典： 银行
    getListDict({ types: "bank" }).then(response => {
      this.bankList = response.data.filter(item => item.type === "bank")[0][
        "dictList"
      ];
    });
    const partyType = this.$store.getters.party.partyType;
    this.isDriver = partyType == "DRIVER" || partyType == "DRIVER_LEADER";
    this.findList();
  },
  methods: {
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "汇总金额";
          }
          if (column.property === "balance") {
            return this.$XEUtils.sum(data, column.property);
          } /*          if (column.property === "ensureFee") {
              return "待定";
            }*/
          // if (column.property === "ensureFeeAmount") {
          //   return this.$XEUtils.sum(data, column.property);
          // }
          return "-";
        })
      ];
    },
    // 翻译开户银行
    formatterBank({ cellValue }) {
      const item = this.bankList.find(item => item.code === cellValue);
      return item ? item.name : "";
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        partyBalanceStatistics(this.listQuery).then(response => {
          this.tableData = response.data.records;
          // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 查看网商余额
    findDetail(code, wsMerchantId) {
      this.parentData.partyCode = code;
      this.parentData.wsMerchantId = wsMerchantId;
      this.$refs.merchantRef.show();
    },
    // 变更明细
    variatclick(c) {
      this.$refs.ShipperlRef.findList(c);
      this.vardel = true;
    },
    // 查询余额
    funcRefresh(info) {
      checkbalance({ partCode: info.code }).then(response => {
        this.$message({
          message: info.enterpriseName + "账户余额：" + response.data.amount,
          type: "success"
        });
        info.balance = response.data.amount;
      });
    },
    // 展示弹框
    showModel(code, prefix) {
      if (code) {
        this.$refs[`${prefix}Ref`].findList(code);
      }
      this[`model${prefix}Flag`] = true;
    },
    // 合计
    // footerMethod({ columns, data }) {
    //   return [
    //     columns.map((column, columnIndex) => {
    //       if (columnIndex === 0) {
    //         return "合计";
    //       }
    //       if (column.property === "balance") {
    //         return this.$XEUtils.sum(data, column.property);
    //       }
    //       return "-";
    //     }),
    //   ];
    // },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
<style scoped lang="scss">
.containerTable {
  .page_title {
    display: flex;
    align-items: center;
    .warn {
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 12px;
      color: #777777;
      .warn_title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 13px;
        color: #000000;
        margin: 0 10px 0 5px;
      }
    }
  }
}
</style>
